import ApiUtil from '../utils/ApiUtil';

const viewAllNotificationsByEmpId = async (empId: number): Promise<unknown> => await
    new Promise((resolve, reject) => {
        ApiUtil.getWithToken(`notifications/${empId}`)
            .then((notification: unknown) => { resolve(notification); })
            .catch((error) => { reject(error); })
    })

const markAssignedNotificationsAsRead = async (id: number): Promise<unknown> => await new Promise((resolve, reject) => {
    ApiUtil.getWithToken(`notification-read/${id}`)
        .then((notificationRead: unknown) => { resolve(notificationRead); })
        .catch((error) => { reject(error); })
})

export { viewAllNotificationsByEmpId, markAssignedNotificationsAsRead }